import { render, staticRenderFns } from "./PatientHeightInput.vue?vue&type=template&id=27619c7d&scoped=true&"
import script from "./PatientHeightInput.vue?vue&type=script&lang=js&"
export * from "./PatientHeightInput.vue?vue&type=script&lang=js&"
import style0 from "./PatientHeightInput.vue?vue&type=style&index=0&id=27619c7d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27619c7d",
  null
  
)

export default component.exports